module.exports = __webpack_public_path__ + "img/logo-easy-history.fad7340a.png";